<script setup>
import KnowledgeBase from 'dashboard/components-next/knowledge-base/KnowledgeBase.vue';
import { useStore, useStoreGetters } from 'dashboard/composables/store';
import { computed, ref } from 'vue';
import { onMounted } from 'vue';
const store = useStore();
const getters = useStoreGetters();

const articles = computed(
  () => {
    const recordInner = getters.getKnowledgeBaseRecords.value;
    return recordInner;
  } // getters.getSortedCannedResponses.value(sortOrder.value)
);
const isLoading = ref(false);
const fetchKnowledgeBaseRecords = async () => {
  try {
    isLoading.value = true;
    await store.dispatch('getKnowledgeBaseRecords');
  } catch (error) {
    // Ignore Error
  } finally {
    isLoading.value = false;
  }
};

const searchKnowledgeBaseArticles = async searchParam => {
  try {
    isLoading.value = true;
    await store.dispatch('getKnowledgeBaseRecords', { searchKey: searchParam });
  } catch (error) {
    // Ignore Error
  } finally {
    isLoading.value = false;
  }
};

onMounted(() => {
  fetchKnowledgeBaseRecords();
});
</script>

<template>
  <KnowledgeBase
    :articles="articles"
    :support-agent="currentUser"
    :is-fetching-article="isLoading"
    @search-articles="searchKnowledgeBaseArticles"
    @refresh="fetchKnowledgeBaseRecords"
  />
</template>
